import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ItemSelectModal from "../common/ItemSelectModal";
import noImg from "../../../img/noimg.png"

let newFileID = 1;
let realFiles = [];
let imageFile = null;
function BomRegModal({ title, onClose, handleRegSuccessSave, MenuUpdateYN}) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [inputItemRows, setInputItemRows] = useState([]);
  const [updateInputItemRows, setUpdateInputItemRows] = useState([]);
  const [inputItemColumns, setInputItemColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    bom_name:'',
    item_id:0,
    item_count:'',
    bigo:'',
    item_name: '',
    item_spec: '',
    item_type_name: '',
    item_division_name: '',
    item_width: 0,
    item_depth: 0,
    item_height: 0,
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectModalOpen, setSelectModalOpen] = useState(false);
  const [selectInputItemData, setSelectInputItemData] = useState('');
  const [checkOpenModalType, setCheckOpenModalType] = useState('');
  
  const handleSetting = () => {
    setInputItemColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {inputItemDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {inputItemAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {inputItemDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'input_item_id', headerName: 'input_item_id', headerAlign: 'center', align:'center' },
      { field: 'input_item_name', headerName: '사용품목명', width: 180, headerAlign: 'center', align:'left' },
      { field: 'input_item_count', headerName: '사용품목수량', width: 120, type: 'number', editable: true, headerAlign: 'center', align:'right' },
      { field: 'input_item_spec', headerName: '사용품목규격', width: 230, headerAlign: 'center', align:'left' },
      { field: 'input_item_type_name', headerName: '사용품목유형', width: 120, type: 'number', headerAlign: 'center', align:'center' },
      { field: 'input_item_division_name', headerName: '사용품목분류', width: 120, type: 'number', headerAlign: 'center', align:'center' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setInputColumnVisibilityModel({
      id: false,
      actions: true,
      input_item_id: false,
      input_item_name: true,
      input_item_count: true,
      input_item_spec: true,
      input_item_type_name: true,
      input_item_division_name: true,
      reg_user_name: false,
      reg_datetime: false,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: true,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [inputColumnVisibilityModel, setInputColumnVisibilityModel] = useState({
    id: false,
    actions: true,
    input_item_id: false,
    input_item_name: true,
    input_item_count: true,
    input_item_spec: true,
    input_item_type_name: true,
    input_item_division_name: true,
    reg_user_name: false,
    reg_datetime: false,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: true,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
      // Mount 될때만 실행된다.
      realFiles = [];
      handleSetting();
      setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);
  
  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<inputItemRows.length; i++){
      if(inputItemRows[i].row_type === 'A' && inputItemRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setInputItemRows((inputItemRows) => [...inputItemRows, { 
        id: Number(appStore.getMaxListID(inputItemRows))+1,
        input_item_id: '',
        input_item_name: '',
        input_item_count: '',
        input_item_spec: '',
        input_item_type_name: '',
        input_item_division_name: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [inputItemRows]);

  useEffect(() => {
    let ADD_YN= 'Y'
    var array = [];
    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){
        array.push({
          id: newFileID,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_name: tmp_file_name,
          file_type_name: tmp_file_type_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_reg_user_name,
          reg_datetime: tmp_reg_datetime,
          row_type:tmp_row_type,
          update_type: tmp_update_type
        })
        newFileID = newFileID + 1;
      }
    }
    setUpdateFileRows(array);
    
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }
    
    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(appStore.getMaxListID(fileRows))+1,
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows]);

  const onSelectChange = (type, value) => {
    const nextInputs = {
        ...inputs,
        [type] : value
    };
    setInputs(nextInputs);
  };

  const onClick = (e)=>{ // inputs 데이터 품목 text 클릭시

    setSelectModalTitle('품목 목록')
    setCheckOpenModalType('I') // 모달 표식 체크
    setSelectModalOpen(true);
    
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processInputRowUpdate = (newRow, oldRow) => {
    //품목 Rows Update
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우
    
    if(newRow.input_item_id !== oldRow.input_item_id || newRow.input_item_count !== oldRow.input_item_count){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_input_item_id = '';
      var row_input_item_count = '';
      var row_input_item_name = '';
      var row_input_item_spec = '';
      var row_input_item_type_name = '';
      var row_input_item_division_name = '';

      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.input_item_id !== '' || newRow.input_item_count !== '' || newRow.input_item_count !== 0){
          row_input_item_id = newRow.input_item_id;
          row_input_item_count = newRow.input_item_count;
          row_input_item_name = newRow.input_item_name;
          row_input_item_spec = newRow.input_item_spec;
          row_input_item_type_name = newRow.input_item_type_name;
          row_input_item_division_name = newRow.input_item_division_name;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        inputItemRows.map((data) => data.id === newRow.id 
          && (data.input_item_id !== newRow.input_item_id || data.input_item_count !== newRow.input_item_count)?
          (
            row_input_item_id = data.input_item_id,
            row_input_item_count = data.input_item_count,
            row_input_item_name = data.input_item_name,
            row_input_item_spec = data.input_item_spec,
            row_input_item_type_name = data.input_item_type_name,
            row_input_item_division_name = data.input_item_division_name
          ):""
        )
      }
      
      if(row_input_item_id === '' && (row_input_item_count === '' || row_input_item_count === 0)){
        // 1. 값이 수정되지 않은 경우.
        if(updateInputItemRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateInputItemRows.length);
          setUpdateInputItemRows(updateInputItemRows.filter((data) => data.id !== newRow.id));
          setInputItemRows(inputItemRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateInputItemRows.length; i++) {
          if(updateInputItemRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateInputItemRows.length);
          setUpdateInputItemRows(updateInputItemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setInputItemRows(inputItemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateInputItemRows.length);
          setUpdateInputItemRows(prevRows => [...prevRows, newUpdateDataArray]);
          setInputItemRows(inputItemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const inputItemAddClick = (object) => {
    //BOM 사용품목 row 추가 버튼
    setInputItemRows((inputItemRows) => [...inputItemRows, { 
      id: Number(appStore.getMaxListID(inputItemRows))+1,
      input_item_id: '',
      input_item_name: '',
      input_item_count: '',
      input_item_spec: '',
      input_item_type_name: '',
      input_item_division_name: '',
      reg_user_name: '',
      reg_datetime: '',
      row_type:'A',
      update_type: 'N'
    }]);
  };

  const inputItemDeleteClick = (object) => {
    //사용품목 row 삭제 버튼
    setUpdateInputItemRows((updateInputItemRows) => updateInputItemRows.filter((data) => data.id !== object.row.id));
    setInputItemRows((inputItemRows) => inputItemRows.filter((data) => data.id !== object.row.id));
  };

  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.type="file";
    input.multiple = true;
    input.click();
    input.onchange = () => {

      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
      }
      
      var array = [];
      for(var i=0; i<realFiles.length; i++){
        var tmp_sever_file_name = realFiles[i].name;
        var tmp_file_name = realFiles[i].name;
        var tmp_file_size = realFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(realFiles[i].size);
        var tmp_file_type = realFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(realFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);

        array.push({
          id: newFileID,
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        })
        newFileID = newFileID + 1;
      }
      setFileRows(array);
    }
  };

  const fileDeleteClick = (object) => {
    //품목 파일 삭제 버튼
    setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
    //품목 파일 다운로드
  };

  const handleOnCellClick = (params) => {
    if(params.field === 'input_item_name'){
      setSelectModalTitle('품목 목록')
      setCheckOpenModalType('U')
      setSelectModalOpen(true);
      setSelectInputItemData({
        id : params.row.id,
        input_item_id: params.row.input_item_id,
        input_item_name: params.row.input_item_name,
        input_item_count: params.row.input_item_count,
        input_item_spec: params.row.input_item_spec,
        input_item_type_name: params.row.input_item_type_name,
        input_item_division_name: params.row.input_item_division_name,
        reg_user_name: params.row.reg_user_name,
        reg_datetime: params.row.reg_datetime,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    }
  };
  
  const handleInputItemClick = (object) => {
    //품목 목록 모달에서 클릭한 값으로 BOM 품목 데이터 설정함.
    if(checkOpenModalType === 'I'){ //inputs
      const nextInputs = {
          ...inputs,
          ["item_id"]: object.id,
          ["item_name"]: object.item_name,
          ["item_spec"]: object.item_spec,
          ["item_type_name"]: object.item_type_name,
          ["item_division_name"]: object.item_division_name,
          ["item_width"]: object.item_width,
          ["item_depth"]: object.item_depth,
          ["item_height"]: object.item_height, 
      };
      setInputs(nextInputs);

    } else if (checkOpenModalType === 'U'){ //rowData
      if(object.id !== selectInputItemData.input_item_id){
        var doubleYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < inputItemRows.length; i++) {
          if(inputItemRows[i].input_item_id === object.id && selectInputItemData.id !== inputItemRows[i].id && object.id !== ''){
            doubleYN = 'Y';
          }
        }
  
        if(doubleYN === 'Y'){
          Swal.fire({
            title: '<p style="color:red">품목 중복 오류</p>',
            text: '이미 추가된 품목이므로, 중복으로 추가할 수 없습니다.',
            confirmButtonText: '확인',
            timer:5000,
            timerProgressBar: true
          });
        }else{
          processInputRowUpdate(
            {
              id : selectInputItemData.id,
              input_item_id: object.id,
              input_item_name: object.item_name,
              input_item_count: selectInputItemData.input_item_count,
              input_item_spec: appStore.ITEM_FULL_SPEC_MAKE(object.item_spec, object.item_width, object.item_depth, object.item_height),
              input_item_type_name: object.item_type_name,
              input_item_division_name: object.item_division_name,
              row_type: selectInputItemData.row_type,
              update_type: selectInputItemData.update_type
            },
            {
              id : selectInputItemData.id,
              input_item_id: selectInputItemData.input_item_id,
              input_item_name: selectInputItemData.input_item_name,
              input_item_count: selectInputItemData.input_item_count,
              input_item_spec: selectInputItemData.input_item_spec,
              input_item_type_name: selectInputItemData.input_item_type_name,
              input_item_division_name: selectInputItemData.input_item_division_name,
              row_type: selectInputItemData.row_type,
              update_type: selectInputItemData.update_type
            }
          )
        }
      }
    }
  };

  const handleSave = (event) => {
    let msg = '';
    let noMaterYN = 'N';
    if((inputs.bom_name).trim() === ''){
      msg = 'BOM명은 필수 입력 입니다.'
    }else if(inputs.item_id === 0 || inputs.item_id === ''){
      msg = '품목명은 필수 선택 입니다.'
    }else if(inputs.item_count === 0 || inputs.item_count < 0 || inputs.item_count === ''){
      msg = '품목수량은 필수 입력 입니다.'
    }
    if(msg === '' && updateInputItemRows.length === 0){ 

      noMaterYN = 'Y';

    }else if(updateInputItemRows.length > 0 && msg === ''){
      for(let i = 0; i < inputItemRows.length; i++) {
        const item_id = inputItemRows[i].input_item_id;
        const item_name = (inputItemRows[i].input_item_name).trim();
        for(let j = i+1; j < inputItemRows.length; j++) {
          if(item_id === inputItemRows[j].input_item_id && item_id !== '' && item_id !== 0) {
            msg = '중복된 사용품목명이 존재합니다.<br/>[중복된 사용품목명 : '+item_name+']';
            break;
          }
        }

        if(msg !== '')  {
          break;
        }
      }

      for(let i = 0; i < updateInputItemRows.length; i++) {
        const item_id = updateInputItemRows[i].input_item_id;
        const item_count = updateInputItemRows[i].input_item_count;
        if(item_id === 0 || item_id === '') {
          msg = '선택되지 않는 사용품목명이 존재합니다.';
          break;
        }
        if(item_count === 0 || item_count < 0 || item_count === '') {
          msg = '입력되지 않는 사용품목 수량이 존재합니다.';
          break;
        }
      }
    }
    

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">BOM 등록 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if(noMaterYN === 'Y'){
        Swal.fire({
          title: 'BOM 사용품목',
          text: 'BOM 사용품목가 없습니다. 그래도 저장 하시겠습니까?',
          showCancelButton: true,
          confirmButtonText: '예', 
          cancelButtonText: '아니오',
          confirmButtonColor: '#0067a3',
          cancelButtonColor: '#d33',
        }).then(result => {
          if (result.isConfirmed) {
            if (appStore.loading) return;
            appStore.setLoading(true);
            
            axios.post("/api/p/Bom/Reg", {inputs, updateInputItemRows} ,
            { withCredentials: true })
            .then(function (response) {
              if(response.status === 200){
                
                var selectID = response.data;
                if(updateFileRows.length > 0) {

                  const formData = new FormData();
                  formData.append('selectID', selectID);
                  formData.append('folder', 'Bom');
                  formData.append('type', 'Reg');
                  formData.append('updateFileRows', JSON.stringify(updateFileRows));
                  
                  for(var i=0; i<realFiles.length; i++){            
                    formData.append('files', realFiles[i]);
                  }
                  
                  axios.post('/api/SaveCommon/GridFileSave'
                      , formData
                      , { headers: { 'Content-Type': 'multipart/form-data' } 
                  }).then(response => {
                    handleRegSuccessSave(selectID);
                  }).catch(error => {
                    appStore.capture();
                  });

                }else{

                  handleRegSuccessSave(selectID);

                }

              }else{
                appStore.capture();
              }
            })
            .catch(function (error) {
              appStore.capture();
            })
            .finally(() => {
              appStore.setLoading(false); 
            });
          }
        })
      }else{
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.post("/api/p/Bom/Reg", {inputs, updateInputItemRows} ,
        { withCredentials: true })
        .then(function (response) {
          if(response.status === 200){
            
            var selectID = response.data;
            if(updateFileRows.length > 0) {

              const formData = new FormData();
              formData.append('selectID', selectID);
              formData.append('folder', 'Bom');
              formData.append('type', 'Reg');
              formData.append('updateFileRows', JSON.stringify(updateFileRows));
              
              for(var i=0; i<realFiles.length; i++){            
                formData.append('files', realFiles[i]);
              }
              
              axios.post('/api/SaveCommon/GridFileSave'
                  , formData
                  , { headers: { 'Content-Type': 'multipart/form-data' } 
              }).then(response => {
                handleRegSuccessSave(selectID);
              }).catch(error => {
                appStore.capture();
              });

            }else{

              handleRegSuccessSave(selectID);

            }

          }else{
            appStore.capture();
          }
        })
        .catch(function (error) {
          appStore.capture();
        })
        .finally(() => {
          appStore.setLoading(false); 
        });
      }
      
    }
  };
  
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="BOM 정보" value="1" />
                <Tab label="BOM 사용품목" value="2" />
                <Tab label="BOM 파일" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">BOM명<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="BOM명" value={inputs.bom_name} name="bom_name" onChange={(e) => onChange(e) } style={{width: '755px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">품목명<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" style={ { cursor:'pointer' } } placeholder="품목명" value={inputs.item_name} name="item_name" onChange={(e) => onChange(e) } onClick={(e) => onClick(e) } autoComplete="off" readOnly/>
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">품목수량<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="number" placeholder="품목수량" value={inputs.item_count} name="item_count" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">품목유형</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="품목유형" value={inputs.item_type_name} name="item_type_name" onChange={(e) => onChange(e) } autoComplete="off" disabled={true} />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">품목분류</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="품목분류" value={inputs.item_division_name} name="item_division_name" onChange={(e) => onChange(e) } autoComplete="off" disabled={true} />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                    <div className="modal_filed">
                      <div className="modal_filed_title">규격</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                        <input type="text" placeholder="규격" value={inputs.item_spec} name="item_spec" onChange={(e) => onChange(e) } style={{width: '155px'}} autoComplete="off" disabled={true} />
                        <div className="modal_filed_title" style={ { width: '100px', paddingLeft: '15px'} }>가로</div>
                          <input type="number" placeholder="가로" value={inputs.item_width} name="item_width" onChange={(e) => onChange(e) } style={{ float: 'left', width: '100px', marginRight: '15px' }} autoComplete="off" disabled={true} />
                        <div className="modal_filed_title" style={ { width: '100px', paddingLeft: '15px'} }>세로</div>
                          <input type="number" placeholder="세로" value={inputs.item_depth} name="item_depth" onChange={(e) => onChange(e) } style={{ float: 'left', width: '100px', marginRight: '15px' }} autoComplete="off" disabled={true} />
                        <div className="modal_filed_title" style={ { width: '100px', paddingLeft: '15px'} }>높이</div>
                          <input type="number" placeholder="높이" value={inputs.item_height} name="item_height" onChange={(e) => onChange(e) } style={{width: '100px'}} autoComplete="off" disabled={true} />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">비고</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="비고" value={inputs.bigo} name="bigo" onChange={(e) => onChange(e) } style={{width: '755px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={inputItemRows}
                  columns={inputItemColumns}
                  columnVisibilityModel={inputColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processInputRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18,  
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    <div className="modal_button">
                      {MenuUpdateYN === 'Y' &&
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                      </Button> }
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {isSelectModalOpen && (<ItemSelectModal
          onClose={() => {
              setSelectModalOpen(false);
          }}
          title={selectmodalTitle}
          handleInputItemClick={handleInputItemClick}
          />)}
    </PCModal>
  );
}

export default BomRegModal;